// extracted by mini-css-extract-plugin
export default {"deviceStatusButton":"DeviceConnectionStatusButton_deviceStatusButton__ASFXK","dotIcon":"DeviceConnectionStatusButton_dotIcon__8T1Bo"};